import * as React from "react";
import AudienceTotalUsersDisclaimer from "./audienceTotalUsersDisclaimer";


const TotalUsers: React.FunctionComponent<ComponentProps> = props => {
  if (!props.id)
    return <React.Fragment></React.Fragment>;

  return (
    <div>
      <div>
        <span>Total users</span>
        <AudienceTotalUsersDisclaimer syncType={props.syncType}/>
      </div>
      <div>{props.totalUsers}</div>
    </div>
  );
}


interface ComponentProps {
  id?: string;
  totalUsers: number;
  syncType: string;
}

export default TotalUsers;